export function initializeKPIMeter() {
	// Select the KPI meter element
	const meter = document.querySelector('.kpi-meter');
	if (meter) {
		// console.log('KPI Meter found:', meter.dataset);
		const minDeg = -90; // Minimum rotation angle for the needle
		const maxDeg = 90;  // Maximum rotation angle for the needle
		const kpiValue = meter.dataset.acpKpi; // Get KPI value from data attribute
		const cpaValue = meter.dataset.acpCpa; // Get CPA value from data attribute
		const cpaDegree = maxDeg - (cpaValue / 100) * 180; // Calculate needle rotation based on CPA %
		const kpiDegree = maxDeg - (kpiValue / 100) * 180; // Calculate target rotation based on KPI target %

		// Apply the rotation after a short delay to allow for animation
		setTimeout(() => {
			meter.style.setProperty('--needle-rotation', `${cpaDegree}deg`);
			meter.style.setProperty('--target-rotation', `${kpiDegree}deg`);
		}, 400);

	}
}
